export const TRANSACTION_TYPES = [
  'any',
  'deposit',
  'bank_deposit',
  'withdraw',
  'bank_withdraw',
  'bond_coupon',
  'fee',
  'adjustment',
  'referral',
  'dividend',
  'commission',
  'securities_deposit',
  'securities_withdraw',
  'instrument_conversion',
  'sales_fee',
  'custody_fee',
  'adr_fee',
  'withdrawal_fee',
  'bond_matured',
  'bond_maturity_payment',
  'loan_disbursement',
  'loan_repayment',
];

export const TRANSACTION_STATUSES = [
  'any',
  'new',
  'accepted',
  'rejected',
  'approved',
  'processed',
  'failed',
  'cancelled',
];

export const TRANSACTION_TYPE_LABELS: Record<string, string> = {
  any: 'Any',
  deposit: 'Deposit',
  bank_deposit: 'Bank Deposit',
  withdraw: 'Withdraw',
  bank_withdraw: 'Bank Withdraw',
  bond_coupon: 'Bond Coupon',
  fee: 'Fee',
  adjustment: 'Adjustment',
  referral: 'Referral',
  dividend: 'Dividend',
  commission: 'Commission',
  securities_deposit: 'Securities Deposit',
  securities_withdraw: 'Securities Withdraw',
  instrument_conversion: 'Instrument Conversion',
  sales_fee: 'Sales Fee',
  custody_fee: 'Custody Fee',
  adr_fee: 'ADR Fee',
  withdrawal_fee: 'Withdrawal Fee',
  bond_matured: 'Matured',
  bond_maturity_payment: 'Maturity Payment',
  loan_disbursement: 'Loan Disbursement',
  loan_repayment: 'Loan Repayment',
};

const TRANSACTION_TYPE_COLORS: Record<string, string> = {
  deposit: 'green',
  bank_deposit: 'cyan',
  withdraw: 'orange',
  bank_withdraw: 'gold',
  bond_coupon: 'purple',
  fee: 'red',
  adjustment: 'blue',
  referral: 'geekblue',
  dividend: 'volcano',
  commission: 'magenta',
  securities_deposit: 'teal',
  securities_withdraw: 'pink',
  instrument_conversion: 'lime',
  sales_fee: 'red',
  // All debits, so they take the colour `fee` already uses for one.
  custody_fee: 'red',
  adr_fee: 'red',
  withdrawal_fee: 'red',
  bond_matured: 'purple',
  bond_maturity_payment: 'green',
  loan_disbursement: 'blue',
  loan_repayment: 'orange',
};

export function getTransactionTypeLabel(transaction: any): string {
  const source = transaction.source || '';
  const label = TRANSACTION_TYPE_LABELS[source] || source;
  if (
    transaction.quantity == 0 &&
    (source === 'withdraw' || source === 'bank_withdraw')
  ) {
    return label + ' Fee';
  }
  return label;
}

export function getTransactionTypeColor(source: string): string {
  return TRANSACTION_TYPE_COLORS[source] || 'default';
}

export function getTransactionStatus(transaction: any): string {
  return (
    transaction.status ||
    (!transaction.status &&
    (transaction.source === 'deposit' || transaction.source === 'bank_deposit')
      ? 'processed'
      : '-')
  );
}

export function getTransactionStatusColor(status: string): string {
  switch (status?.toLowerCase()) {
    case 'processed':
    case 'approved':
    case 'accepted':
      return 'green';
    case 'failed':
    case 'rejected':
    case 'cancelled':
      return 'red';
    case 'new':
      return 'blue';
    default:
      return 'default';
  }
}

export function getTransactionAmount(transaction: any): string {
  if (
    transaction.quantity == 0 &&
    (transaction.source === 'withdraw' ||
      transaction.source === 'bank_withdraw')
  ) {
    return transaction.fee || '0';
  }
  return transaction.quantity || '0';
}

export function getTransactionFee(transaction: any): string {
  return transaction.fee || '0';
}

/** Fee-type rows (`fee`, `sales_fee`, `custody_fee`, …): the amount is the fee itself. */
export function isFeeTransaction(transaction: any): boolean {
  return transaction?.source === 'fee' || !!transaction?.source?.endsWith('_fee');
}

export function truncateTxId(txId: string, length = 8): string {
  if (!txId) return '-';
  if (txId.length <= length * 2) return txId;
  return `${txId.substring(0, length)}...${txId.substring(
    txId.length - length
  )}`;
}
